import _defineProperty from "/home/node/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { EventType } from "./constants/eventType";
import { pageViewEvent } from "./events/pageViewEvent";
var track = function track(event) {
  try {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && _window.dataLayer && event) {
      window.dataLayer.push(event);
    }
  } catch (error) {
    console.error('Error tracking GA event', error);
  }
};
var gtmEventHandler = _defineProperty({}, EventType.PAGE_VIEW, pageViewEvent);
var createEvent = function createEvent(_ref) {
  var type = _ref.type,
    payload = _ref.payload;
  try {
    var eventBuilder = gtmEventHandler[type];
    return eventBuilder(payload);
  } catch (error) {
    console.error('Error creating GA event', error);
  }
};
export { createEvent, track };